import React from "react";

const SPContentWrap = (props: any) => {
    const { children } = props;
        return <div {...props}>{children}</div>;
}

export default SPContentWrap;

